export default __webpack_public_path__ + "static/media/test.a359be95.jpeg";